<template>
  <BaseDialog
    type="basic"
    :title="$t('coachees.addDialog.title')"
    :is-open="isOpen"
    class="md:w-[400px]"
    @close="emits('close')"
  >
    <div class="flex flex-col">
      <p class="text-body-medium text-on-surface-variant -mt-1 mb-0.5">
        {{ $t('coaching.addCoachees.description') }}
      </p>
      <BaseMemberSelect
        v-model="selectedMemberIds"
        :label="$t('common.coachees', { count: 2 })"
        class="bg-surface-container-high"
        display-selected="list"
        :show-select-all-button="true"
        filter="non-coachees"
      />
    </div>
    <template #dismiss>
      <BaseTextButton color="text" @click="emits('close')">{{
        $t('common.cancel')
      }}</BaseTextButton>
    </template>
    <template #confirm>
      <BaseTextButton
        color="filled"
        :disabled="selectedMemberIds.length == 0"
        @click="addCoachee"
        >{{ $t('common.add') }}</BaseTextButton
      >
    </template>
  </BaseDialog>
</template>
<script lang="ts" setup>
  import BaseDialog from '../../../core/components/base/dialog/BaseDialog.vue'
  import BaseMemberSelect from '../../../core/components/base/member-select/BaseMemberSelect.vue'
  import { ref, watch } from 'vue'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'

  interface Props {
    isOpen: boolean
  }

  const props = defineProps<Props>()

  const emits = defineEmits<{
    (e: 'close'): void
    (e: 'addCoachees', coacheeIds: string[]): void
  }>()

  const selectedMemberIds = ref<string[]>([])

  watch(
    () => props.isOpen,
    (newVal) => {
      if (newVal) {
        selectedMemberIds.value = []
      }
    },
  )

  const addCoachee = () => {
    emits('addCoachees', selectedMemberIds.value)
    emits('close')
  }
</script>
